export default __webpack_public_path__ + "static/How to improve Chinese_1-8915bcb598c722037bcba87a132d80da.png";